// extracted by mini-css-extract-plugin
module.exports = {"custom_err_msg_section":"Page400_custom_err_msg_section__3hxQ2","fs_big":"Page400_fs_big__380lj","fs_22":"Page400_fs_22__ifn3d"};